export default {
  wrapper: {
    width: 100,
    height: 100,
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/Loading/styles.js